module.exports = __webpack_public_path__ + "media/images/news/stop-39897b815ab0c2072c145ac1ccf80e1b.png";